The date the degree was granted or is expected to be granted.

This may only contain a year and optional month, e.g. `2020` or `2020-06`.
If the date isn't known this will be `null`.
